import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { formatMoney } from "../../utils/formatMoney";

export default function PaymentSuccessModal({ 
  isOpen, 
  onClose, 
  policyData,
  transactionId 
}) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleViewPolicies = () => {
    onClose();
    navigate("/my-policies");
  };

  const handleBrowseMore = () => {
    onClose();
    navigate("/insurance");
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="relative w-full max-w-md mx-4 bg-white rounded-2xl shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-xl font-bold text-gray-900">Step 3 Complete!</h3>
              <p className="text-sm text-gray-600 mt-1">Payment Confirmation</p>
            </div>
            <button
              onClick={onClose}
              className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {/* Success Icon */}
          <div className="text-center">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              className="w-16 h-16 mx-auto bg-emerald-100 rounded-full flex items-center justify-center mb-3"
            >
              <svg className="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </motion.div>
            
            <h4 className="text-lg font-semibold text-gray-900 mb-2">
              Payment Successful!
            </h4>
            <p className="text-sm text-gray-600 mb-4">
              Your policy is now active. Details sent to your email.
            </p>
          </div>

          {/* Policy Summary */}
          <div className="p-3 bg-emerald-50 border border-emerald-200 rounded-lg">
            <div className="flex justify-between items-center text-sm">
              <span className="text-emerald-700">{policyData.policyType}</span>
              <span className="font-semibold text-emerald-900">{formatMoney(policyData.amount || 0, "₵ ")}</span>
            </div>
            {transactionId && (
              <div className="mt-2 text-xs text-emerald-600">
                ID: {transactionId}
              </div>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="p-6 border-t border-gray-100 space-y-3">
          <button
            onClick={handleViewPolicies}
            className="w-full px-4 py-3 text-sm font-semibold text-white bg-emerald-600 rounded-xl hover:bg-emerald-700 transition-colors"
          >
            View My Policies
          </button>
          <button
            onClick={handleBrowseMore}
            className="w-full px-4 py-3 text-sm font-semibold text-emerald-700 bg-emerald-50 rounded-xl hover:bg-emerald-100 transition-colors"
          >
            Browse More Policies
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
}
